export default "__VITE_ASSET__jgBZZRqQ__"